import Image from 'next/image';
import styles from './footer.module.scss';
import { PATH } from 'data';
import { ThemeEnum } from 'types';
import Link from 'next/link';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import logoLight from 'assets/images/logo-light.png';
import logoDark from 'assets/images/logo-dark.png';
import { FaFacebookF, FaTelegramPlane, FaTwitter, FaYoutube } from 'react-icons/fa';
import { COLORS } from 'utilities';
import { RiWhatsappFill } from 'react-icons/ri';
import Mojavez from 'assets/images/leagals/mojavez-ir.svg';
import IranianAsnaf from 'assets/images/leagals/iranianasnaf';
export default function FooterComp() {
    const { theme } = useContext(GlobalContext);
    return (
        <footer className={`${styles['footer']} d-pre-md-none`}>
            <div className="flex-column h-100 main-content">
                <div className={`${styles['top-section']} d-flex center-content-y justify-content-between`}>
                    <div className="g-lg-5 g-pre-lg-3 center-content-y">
                        <Link href={PATH.home} className="align-items-center g-1">
                            <Image
                                src={theme === ThemeEnum.dark ? logoDark : logoLight}
                                alt="آقای شهر"
                                width={77}
                                height={30}
                            />
                        </Link>
                        <div className="center-content-y g-lg-4 g-pre-lg-2">
                            <Link href={PATH.aboutUs} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">درباره ما</p>
                            </Link>
                            <Link href={PATH.terms} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">قوانین و مقررات</p>
                            </Link>
                            <Link href={PATH.panel.tickets.new()} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">ثبت درخواست پشتیبانی</p>
                            </Link>
                            <Link href={PATH.download} target="_blank">
                                <p className="t-p1 t-400 t-l-black1 t-d-gray3">دریافت اپلیکیشن</p>
                            </Link>
                        </div>
                    </div>
                    <div className="d-flex g-3 center-content">
                        <div className={`${styles['service']}`}>
                            <a
                                style={{ width: '100%', height: '100%', display: 'flex' }}
                                referrerPolicy="origin"
                                target="_blank"
                                href="https://trustseal.enamad.ir/?id=556675&Code=yFHiUjpo2yB7PpY10JAXTPkHZUJNEMZy"
                            >
                                <img
                                    {...{ code: 'yFHiUjpo2yB7PpY10JAXTPkHZUJNEMZy' }}
                                    referrerPolicy="origin"
                                    src="https://trustseal.enamad.ir/logo.aspx?id=556675&Code=yFHiUjpo2yB7PpY10JAXTPkHZUJNEMZy"
                                    alt=""
                                    style={{ cursor: 'pointer' }}
                                />
                            </a>
                        </div>
                        <div className={`${styles['service']} d-none`}>
                            <a href="https://apinovin.iranianasnaf.ir/parvaneh/7b5ae770-4486-4f9d-ac8a-5348977da78b/html">
                                <img
                                    src={IranianAsnaf}
                                    alt="Iranian Asnaf"
                                    style={{ width: '100%', height: '100%', display: 'flex' }}
                                />
                            </a>
                        </div>
                        <div className={`${styles['service']} d-none`}>
                            <a
                                href="https://qr.mojavez.ir/track/15658225"
                                style={{ width: '100%', height: '100%', display: 'flex' }}
                            >
                                <Image src={Mojavez} alt="Mojavez" />
                            </a>
                        </div>
                        {/* <div className={`${styles['service']}`}></div>
                        <div className={`${styles['service']}`}></div> */}
                    </div>
                </div>
            </div>
            <div className={`${styles['bottom-section']}`}>
                <div className="main-content justify-content-between">
                    <p className="t-p1 t-400 t-l-black1 t-d-gray3">
                        کلیه حقوق این سایت متعلق به آقای <span className="t-l-primary t-d-primary">شهر</span> است.
                    </p>
                    <div className="g-3 center-content-y">
                        <FaFacebookF color={COLORS.primary} size={24} />
                        <FaTelegramPlane color={COLORS.primary} size={24} />
                        <FaTwitter color={COLORS.primary} size={24} />
                        <RiWhatsappFill color={COLORS.primary} size={24} />
                        <FaYoutube color={COLORS.primary} size={24} />
                    </div>
                </div>
            </div>
        </footer>
    );
}
